import { OnChangeParams } from 'baseui/select';
import { useMemo } from 'react';
import { FUEL_TYPE_OPTIONS } from '../../../constants/asset';
import { FuelType } from '../../../types/asset';
import { EnhancedLabeledSelect } from '../../ui/EnhancedLabeledSelect';

type Props = {
  selectedId?: FuelType;
  onChangeId?: (id?: FuelType) => void;
  isFilter?: boolean;
  label?: string;
  emptyOptionText?: string;
  showEmptyOption?: boolean;
  error?: React.ReactNode;
  onBlur?: () => void;
  inline?: boolean;
  clearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  selectMaxWidth?: number;
};

function FleetAssetFuelTypeSelect({
  selectedId,
  onChangeId,
  isFilter = false,
  label = 'Tipo de combustible:',
  emptyOptionText = 'Seleciona un tipo',
  showEmptyOption = false,
  error,
  onBlur,
  inline,
  clearable = false,
  required = false,
  disabled = false,
  selectMaxWidth,
}: Readonly<Props>) {
  const fuelTypeOptions = useMemo(() => {
    const coreOptions = FUEL_TYPE_OPTIONS;
    const options = showEmptyOption
      ? [
          {
            id: undefined,
            label: isFilter ? 'Todos' : emptyOptionText,
          },
          ...coreOptions,
        ]
      : coreOptions;
    return options;
  }, [isFilter, showEmptyOption, emptyOptionText]);

  const onSelectedChange = (params: OnChangeParams) => {
    if (params.option?.id) {
      onChangeId?.(params.option.id as FuelType);
    } else {
      onChangeId?.(undefined);
    }
  };

  return (
    <EnhancedLabeledSelect
      label={label}
      options={fuelTypeOptions}
      value={showEmptyOption || selectedId !== undefined ? [{ id: selectedId }] : undefined}
      onChange={onSelectedChange}
      fullWidth
      onBlur={() => {
        onBlur?.();
      }}
      searchable
      inline={inline}
      inset={inline}
      error={error}
      required={required}
      clearable={clearable}
      placeholder={emptyOptionText}
      disabled={disabled}
      selectMaxWidth={selectMaxWidth}
    />
  );
}

export default FleetAssetFuelTypeSelect;
